import { useAuthenticatedUser } from 'contexts'
import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { PATHS } from 'utils/constants'
import { useLoading } from 'utils/hooks'

const UnauthenticatedRoute = () => {
  const { authenticatedUser, isLoading } = useAuthenticatedUser()
  const { Loading } = useLoading()
  const isAuthenticated = authenticatedUser.clientPrincipal !== null

  if (isLoading) {
    return <Loading />
  }

  return isAuthenticated ? <Navigate to={PATHS.home} /> : <Outlet />
}

export default UnauthenticatedRoute
